const $ = require('jquery');
const forEach = require('lodash.foreach');

const $jumpmenu = $('.paragraph--type--jump-menu');

createJumpMenus();
attachJumpMenuHandler();

function createJumpMenus() {
  forEach($jumpmenu, thismenu => {
    const options = $(thismenu).find('a');
    const title = $(thismenu).find('div')[0].innerText;
    const select = $(
      `<div class="jump-menu-wrapper"><select class="jump-menu"><option value="">${title}</option></select></div>`,
    );

    forEach(options, item => {
      const option = $('<option></option>');
      option.attr('value', item.getAttribute('href'));
      option.text(item.innerText);
      select.find('select').append(option);
    });
    // console.log(thismenu);
    $(thismenu).empty().append(select);
  });
}

function attachJumpMenuHandler() {
  $('.jump-menu').on('change', event => {
    event.preventDefault();
    const url =
      event.currentTarget.options[event.currentTarget.selectedIndex].value;
    if (url) {
      self.location = url;
    }
  });
}
